import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { ReportReasonItem } from '../../../../state/types';
import styles from './ReportReasons.module.scss';
import Icon from 'utils/components/icon';
import { ReasonItem } from './TagInfo';
import classNames from 'classnames';

interface ReasonsType {
  reasons: {
    [key: string]: Array<ReportReasonItem>;
  };
}

export const ReportReasons = (reasonsProps: ReasonsType): ReactElement => {
  const reasonsArr = useMemo(() => sortReasons(Object.entries(reasonsProps.reasons)), [
    reasonsProps.reasons
  ]);
  const [reportClicked, setReportClicked] = useState<number>(0);
  const singleReport = reasonsArr.length === 1;
  useEffect(() => {
    setReportClicked(0);
  }, [singleReport]);

  const toggleActive = (index: number) => {
    if (reportClicked === index) {
      return setReportClicked(null);
    }
    setReportClicked(index);
  };
  return (
    <div className={singleReport ? styles.singleReportTab : styles.reportReasonTab}>
      {reasonsArr.map(([reason, reasonsObjectArr], index) => {
        const isCurrentIndex = reportClicked === index;
        return (
          <div key={reason}>
            <div
              className={isCurrentIndex ? styles.reportAccordionOpen : styles.reportAccordion}
              onClick={singleReport ? undefined : () => toggleActive(index)}
            >
              {reason.replace(/_/g, ' ')}{' '}
              <span className={styles.notbold}>({reasonsObjectArr.length})</span>
              {!singleReport && (
                <Icon
                  name="chevron-down"
                  className={classNames(styles.chevron, {
                    [styles.flipped]: isCurrentIndex
                  })}
                />
              )}
            </div>
            <div
              className={classNames(styles.reportAccordionItem, {
                [styles.open]: isCurrentIndex
              })}
            >
              {reasonsObjectArr.map(
                ({ username, description: { user_description } }, reasonIndex) => {
                  // Done assuming the empty descriptions will be at the end of the array
                  // This is in accordance with the backend
                  const hideComma = reasonIndex === reasonsObjectArr.length - 1;
                  if (user_description && user_description.length > 0) {
                    return (
                      <ReasonItem
                        className={styles.userReportSection}
                        username={username}
                        description={user_description}
                        key={reasonIndex}
                      />
                    );
                  } else {
                    return (
                      <span className={styles.emptyDescUsers} key={reasonIndex}>
                        @{username}
                        {!hideComma && ','}{' '}
                      </span>
                    );
                  }
                }
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

/**
 * This function sorts the reasons array by number of reports.
 * @param reasons
 * @returns sorted reasons by number of reports.
 */
const sortReasons = (reasons: Array<[string, ReportReasonItem[]]>) => {
  return reasons.sort((a, b) => {
    if (a[1].length > b[1].length) {
      return -1;
    }
    if (a[1].length < b[1].length) {
      return 1;
    }
    return 0;
  });
};
